import type { FieldDescriptor } from '@/types/fieldDescriptor';

export const BANK_DETAILS_FIELDS: FieldDescriptor[] = [
  {
    id: 'nameAsInBankAccount',
    fieldType: 'TEXT',
    label: 'Name as in bank account',
    placeholder: 'Enter name as in bank account',
    validation: {
      required: true,
      minLength: 1,
      errorMessage: 'Name as in bank account is required',
    },
  },
  {
    id: 'bankName',
    fieldType: 'TEXT',
    label: 'Bank name',
    placeholder: 'Enter bank name',
    validation: {
      required: true,
      minLength: 1,
      errorMessage: 'Bank name is required',
    },
  },
  {
    id: 'bankAccountNumber',
    fieldType: 'TEXT',
    label: 'Account number',
    placeholder: 'Enter account number',
    validation: {
      required: true,
      minLength: 9,
      maxLength: 18,
      pattern: '^\\d+$',
      patternMessage: 'Account number must contain only digits',
      errorMessage: 'Account number must be at least 9 digits',
    },
    inputProps: { inputMode: 'numeric' },
  },
  {
    id: 'confirmBankAccountNumber',
    fieldType: 'TEXT',
    label: 'Confirm account number',
    placeholder: 'Re-enter account number',
    validation: {
      required: true,
      minLength: 1,
      errorMessage: 'Please confirm account number',
    },
    inputProps: { inputMode: 'numeric' },
  },
  {
    id: 'ifscCode',
    fieldType: 'TEXT',
    label: 'IFSC code',
    placeholder: 'Enter IFSC code',
    validation: {
      required: true,
      minLength: 11,
      maxLength: 11,
      pattern: '^[A-Z]{4}0[A-Z0-9]{6}$',
      patternMessage: 'Please enter a valid IFSC code',
    },
    inputProps: { maxLength: 11 },
    transform: { toStore: (raw) => raw.toUpperCase() },
  },
];
